module.exports = __webpack_public_path__ + "static/instruction2.7e02c68a.svg";